/* eslint-disable complexity */
import './CommonSearchFilterPanel.css';

import React, { useCallback } from 'react';
import { Typography, Button } from '@vtblife/uikit';

import classname from '@search/classname/src';
import { errorCatcherWrap } from '@search/error/src/catcher';

import { RealtyObjectType, DealType, AreaUnit } from '@search/filter-enums/enums';
import { RegionIdEnum, regionsWithMetroEnumeration } from '@search/filter-enums/enums/Region';
import { useGeoRootRegion } from '@search/geo/src/GeoRootRegionProvider';

import { RegionSelector2 } from '@search/classified-common/src/RegionSelector2/RegionSelector2';
import { classifiedFilterFactory } from '../../../../domain/offer/filters/ClassifiedFilterFactory';
import {
    Filters,
    IFilter,
    RegionFilter,
    GeoFilter,
    MapBoundsFilter,
    TransportLimitFilter,
    MortgagePaymentFilter
} from '../../../filters/models/Filter';
import {
    MobileDealTypeFilterView
} from '../../../filters/components/filter_types/mobile/dealType/MobileDealTypeFilterView';
import {
    MobileRealtyTypeFilterView
} from '../../../filters/components/filter_types/mobile/realtyType/MobileRealtyTypeFilterView';
import {
    MobileHouseCategoryFilterView
} from '../../../filters/components/filter_types/mobile/houseCategory/MobileHouseCategoryFilterView';
import { MobilePriceFilterView2 } from '../../../filters/components/filter_types/mobile/price/MobilePriceFilterView2';
import {
    MobileSellerFilterButtonView
} from '../../../filters/components/filter_types/mobile/seller/MobileSellerFilterButtonView';
import {
    MobileTransportLimitFilterView2
} from '../../../filters/components/filter_types/mobile/transportLimit/MobileTransportLimitFilterView2';
import { FilterTagListItem } from '../../../filters/components/filter_types/desktop/geo/FilterTagList/FilterTagListItem';
import {
    DesktopRoomsInOfferFilterView
} from '../../../filters/components/filter_types/desktop/roomInOffer/DesktopRoomsInOfferFilterView';
import {
    DesktopRoomInFlatFilterView
} from '../../../filters/components/filter_types/desktop/roomInFlat/DesktopRoomInFlatFilterView';
import {
    DesktopLandAreaFilterView
} from '../../../filters/components/filter_types/desktop/landArea/DesktopLandAreaFilterView';
import {
    DesktopRoomInHouseFilterSelectView
} from '../../../filters/components/filter_types/desktop/roomInHouse/DesktopRoomInHouseFilterSelectView';
import {
    DesktopHouseAreaFilterView
} from '../../../filters/components/filter_types/desktop/houseArea/DesktopHouseAreaFilterView';
import { LivingAreaFromFilterView } from '../../../filters/components/filter_types/living_area/LivingAreaFromFilter';
import { KitchenAreaFromFilterView } from '../../../filters/components/filter_types/kitchen_area/KitchenAreaFilter';
import { FloorsTotalFilterView } from '../../../filters/components/filter_types/floors_total/FloorsTotalFilter';
import { AreaFilterView } from '../../../filters/components/filter_types/area/AreaFilter';
import { YearBuildingFilterView } from '../../../filters/components/filter_types/year_building/YearBuildingFilter';
import { ClassifiedFilterCollection } from '../../../../domain/offer/filters/ClassifiedFilterCollection';
import {
    MobileNewBuildingFilterView
} from '../../../filters/components/filter_types/mobile/newBuilding/MobileNewBuildingFilterView';
import {
    MobileApartmentsButtonFilterView
} from '../../../filters/components/filter_types/mobile/apartments/MobileApartmentsButtonFilterView';
import {
    MobileLandStatusSelectFilter
} from '../../../filters/components/filter_types/mobile/landStatus/MobileLandStatusSelectFilter';
import {
    MobileAdditionallyOptionsFilterView
} from '../../../filters/components/filter_types/mobile/additionally/MobileAdditionallyOptionsFilterView';
import {
    SupplyOptionsButtonFilterView
} from '../../../filters/components/filter_types/group/SupplyOptionsButtonFilterView';
import {
    MobileRenovationButtonFilterView
} from '../../../filters/components/filter_types/mobile/renovation/MobileRenovationButtonFilterView';
import {
    MobileFloorFilterButtonView
} from '../../../filters/components/filter_types/mobile/floor/MobileFloorFilterButtonView';
import {
    MobileCeilHeightFilterButtonView
} from '../../../filters/components/filter_types/mobile/ceilHeight/MobileCeilHeightFilterButtonView';
import {
    MobileBathroomFilterButtonView
} from '../../../filters/components/filter_types/mobile/bathroom/MobileBathroomFilterButtonView';
import {
    MobileWindowDirectionFilterButtonView
} from '../../../filters/components/filter_types/mobile/window/MobileWindowDirectionFilterButtonView';
import {
    MobileBalconyFilterButtonView
} from '../../../filters/components/filter_types/mobile/balcony/MobileBalconyFilterButtonView';
import {
    MobileDistrictFilterButtonView
} from '../../../filters/components/filter_types/mobile/district/MobileDistrictFilterButtonView';
import {
    MobileWallsFilterButtonsView
} from '../../../filters/components/filter_types/mobile/walls/MobileWallsFilterButtonsView';
import {
    MobileInfrastructureFilterButtonView
} from '../../../filters/components/filter_types/mobile/infrastructure/MobileInfrastructureFilterButtonView';
import {
    MobileRenovationProgramFilterButtonView
} from '../../../filters/components/filter_types/mobile/renovationProgram/MobileRenovationProgramFilterButtonView';
import {
    MobileRentConditionsFilterButtonView
} from '../../../filters/components/filter_types/mobile/rentConditions/MobileRentConditionsFilterButtonView';
import {
    MobilePrePaymentFilterButtonView
} from '../../../filters/components/filter_types/mobile/pre_payment/MobilePrePaymentFilterButtonView';
import {
    MobileLivingFacilityFilterButtonView
} from '../../../filters/components/filter_types/mobile/living_facility/MobileLivingFacilityFilterButtonView';
import {
    MobileFurnitureFilterButtonView
} from '../../../filters/components/filter_types/mobile/furniture/MobileFurnitureFilterButtonView';
import {
    MobileRoomFilterButtonView
} from '../../../filters/components/filter_types/mobile/room/MobileRoomFilterButtonView';
import {
    ClMobileFinishingTypeFilterView
} from '../../../filters/components/filter_types/mobile/finishing_type/ClMobileFinishingTypeFilterView';
import { CommissioningDateFilter } from '../../../filters/components/filter_types/commissioning_date/CommissioningDateFilter';

const cn = classname.bind(null, 'CommonSearchFilterPanel');

export function getPriceTypes(filters: ClassifiedFilterCollection) {
    if (filters.isSellFilterActive()) {
        if (filters.isHouseFilterActive() || filters.isFlatOrRoomFilterActive()) {
            return [ AreaUnit.UNKNOWN, AreaUnit.METER, AreaUnit.MORTGAGE_PAYMENT ];
        }
        return [ AreaUnit.UNKNOWN, AreaUnit.ARE ];
    }

    return [ ];
}

function getFilterSectionTitleByCategory(categoryType: RealtyObjectType) {
    switch (categoryType) {
        case RealtyObjectType.LAND:
            return 'Участок';
        case RealtyObjectType.HOUSE:
            return 'Дом';
        case RealtyObjectType.ROOM:
            return 'Комната';
        case RealtyObjectType.FLAT:
        default:
            return 'Квартира';
    }
}

function getEnabledDealItems(categoryType: RealtyObjectType) {
    if (categoryType === RealtyObjectType.LAND) {
        return [ DealType.SELL ];
    }

    return [ DealType.SELL, DealType.RENT ];
}

function getEnabledSegments(dealType: DealType) {
    if (dealType === DealType.RENT) {
        return [ RealtyObjectType.FLAT, RealtyObjectType.ROOM, RealtyObjectType.HOUSE ];
    }

    return [ RealtyObjectType.FLAT, RealtyObjectType.ROOM, RealtyObjectType.LAND, RealtyObjectType.HOUSE ];
}

export const CommonSearchFilterPanel: React.FC<{
    filters: ClassifiedFilterCollection;
    showMapArea?(): void;
    removeDrawArea?: () => void;
    regionUpdated: (region: RegionIdEnum) => void;
    updateFilters: (filters: ClassifiedFilterCollection) => void;

    isMobile?: boolean;
    className?: string;
    renderGeoFilter: (cb: (filterList: IFilter[]) => void) => React.ReactNode;
    renderSellTypeFilter: (cb: (filter: IFilter) => void) => React.ReactNode;
    handleInteractionOnFilter?: () => void;
    prefixNodes?: React.ReactNode[];
    renderDividerContent?: React.ReactNode;
}> = errorCatcherWrap(({
    filters,
    regionUpdated,
    updateFilters,
    removeDrawArea,
    isMobile,
    renderGeoFilter,
    renderSellTypeFilter,
    children,
    className,
    handleInteractionOnFilter,
    prefixNodes,
    renderDividerContent
}) => {
    const mapBoundsFilter = filters.get(Filters.mapBounds) as MapBoundsFilter;

    let drawAreaTitle;

    if (mapBoundsFilter?.hasPolygon() || mapBoundsFilter.geohash) {
        drawAreaTitle = 'Область на карте';
    } else if (mapBoundsFilter?.bounds) {
        drawAreaTitle = 'Область карты';
    }

    const updateFilter = useCallback((filter: IFilter) => {
        if (filter.id === Filters.region) {
            if (! regionsWithMetroEnumeration.has((filter as RegionFilter).region)) {
                filters.update(new TransportLimitFilter());
            }
            filters.update(new MapBoundsFilter());
        }

        const newFilters: ClassifiedFilterCollection = classifiedFilterFactory
            .createOrUpdateFilters(filters.update(filter).getFilters(), filter);

        updateFilters(newFilters);
    }, [ filters, updateFilters ]);

    const updateFewFilters = useCallback((filterList: IFilter[]) => {
        filterList.forEach(filter => {
            if (filter.id === Filters.region) {
                const regionFilter = filter as RegionFilter;

                regionUpdated(regionFilter.region);
            }
            updateFilter(filter);
        });
    }, [ updateFilter, regionUpdated ]);

    const updateRegion = useCallback((filter: RegionFilter) => {
        regionUpdated(filter!.region);
        updateFilter(filter);
        updateFilter(new GeoFilter());
    }, [ regionUpdated, updateFilter ]);

    if (! filters) {
        return null;
    }

    const priceTypes = getPriceTypes(filters);

    const containerRef = React.useRef<HTMLDivElement | null>(null);
    const rootRegions = useGeoRootRegion();

    const renderBuildingFilters = filters.isLandFilterActive() ? null : (<>
        <YearBuildingFilterView
            filter={filters.get(Filters.builtYear)}
            handleChange={updateFilter}
            // @ts-ignore
            filter2={filters.get(Filters.buildEpoch)}
            isMobile
        />
        <FloorsTotalFilterView
            filter={filters.get(Filters.floorsTotal)}
            handleChange={updateFilter}
            isMobile
        />
    </>);

    const commonPart = (<>
        <div className={cn('filter-subsection-rows')}>
            <RegionSelector2
                isMobile={isMobile}
                selectedId={(filters.get(Filters.region) as RegionFilter).region}
                items={rootRegions.items}
                onSelectId={id => updateRegion(new RegionFilter(id))}
            />
            <div className={cn('filter-subsection-columns')}>
                <MobileDealTypeFilterView
                    filter={filters.get(Filters.dealType)}
                    enabledDealTypes={getEnabledDealItems(filters.getCategoryTypeFilter().categoryType)}
                    handleChange={updateFilter}
                    native={isMobile}
                />
                <MobileRealtyTypeFilterView
                    enabledSegments={getEnabledSegments(filters.getDealTypeFilter().dealType)}
                    filter={filters.get(Filters.categoryType)}
                    handleChange={updateFilter}
                    native={isMobile}
                />
            </div>
            {filters.isNewBuildingShown() &&
                <MobileNewBuildingFilterView
                    filter={filters.get(Filters.newBuilding)}
                    handleChange={updateFilter}
                    classNameGroup={cn('grid-realty-type')}
                />
            }
        </div>
        {renderGeoFilter(updateFewFilters)}
        {drawAreaTitle && removeDrawArea ? (
            <FilterTagListItem
                id='draw-area'
                isActive
                onDelete={removeDrawArea}
            >{drawAreaTitle}</FilterTagListItem>
        ) : null}
        {filters.isFlatFilterActive() && (
            <MobileRoomFilterButtonView
                filter={filters.get(Filters.rooms)}
                kitchenAreaFilter={filters.get(Filters.kitchenArea)}
                handleChange={updateFilter}
                classNameGroup={cn('grid-house-category')}
                classNameSeparate={cn('separate')}
                isRent={filters.isRentFilterActive()}
                isMap={! isMobile}
            />
        )}
        {filters.isHouseFilterActive() && (
            <MobileHouseCategoryFilterView
                classNameGroup={cn('grid-house-category')}
                filter={filters.get(Filters.houseCategory)}
                handleChange={updateFilter}
            />
        )}
        <MobilePriceFilterView2
            filter={filters.get(Filters.price)}
            priceTypes={priceTypes}
            handleChange={updateFilter}
            updateFewFilters={updateFewFilters}
            mortgagePaymentFilter={filters.get(Filters.mortgagePayment) as MortgagePaymentFilter}
        />
        {filters.isSellFlatOrRoomFilterActive() && (
            <AreaFilterView
                filter={filters.get(Filters.totalArea)}
                handleChange={updateFilter}
                isMobile
            />
        )}
        {filters.isSellFilterActive() && (
            <MobileSellerFilterButtonView
                filter={filters.get(Filters.author)}
                handleChange={updateFilter}
                classNameGroup={cn('grid-house-category')}
                isSecond={filters.isOnlySecond() || filters.isRoomFilterActive() || filters.isLandOrHouseFilterActive()}
            />
        )}
    </>);

    const locationPart = (<>
        {filters.hasMetroInRegion() ? (
            <MobileTransportLimitFilterView2
                containerClass={cn('grid-metro-time')}
                isMobile={isMobile}
                isTitle
                filter={filters.get(Filters.transportLimit)}
                onChange={updateFilter}
                isShort
            />
        ) : null}
    </>);

    const generalPart = (<>
        {filters.isRentFlatOrRoomFilterActive() && (
            <AreaFilterView
                filter={filters.get(Filters.totalArea)}
                handleChange={updateFilter}
                isMobile
            />
        )}
        {filters.isSellFlatFilterActive() && (
            <MobileApartmentsButtonFilterView
                filter={filters.get(Filters.apartments)}
                handleChange={updateFilter}
                classNameGroup={cn('grid-subgroup')}
            />
        )}
        {filters.isSellRoomFilterActive() && (<>
            <DesktopRoomInFlatFilterView
                classNameGroup={cn('grid-rooms')}
                filter={filters.get(Filters.rooms)}
                handleChange={updateFilter}
            />
            <DesktopRoomsInOfferFilterView
                classNameGroup={cn('grid-rooms')}
                filter={filters.get(Filters.roomsInOffer)}
                dealType={filters.getDealTypeFilter().dealType}
                handleChange={updateFilter}
            />
        </>)}
        {filters.isHouseFilterActive() && (<>
            <DesktopHouseAreaFilterView
                filter={filters.get(Filters.houseArea)}
                handleChange={updateFilter}
            />
        </>)}
        {filters.isLandOrHouseFilterActive() && (<>
            <DesktopLandAreaFilterView
                filter={filters.get(Filters.landArea)}
                handleChange={updateFilter}
            />
            {filters.isLandFilterActive() && (
                <MobileLandStatusSelectFilter
                    filter={filters.get(Filters.landStatus)}
                    onChange={updateFilter}
                />
            )}
            {filters.isHouseFilterActive() && (<>
                <DesktopRoomInHouseFilterSelectView
                    isMobile
                    filter={filters.get(Filters.rooms)}
                    handleChange={updateFilter}
                    classNameGroup={cn('grid-rooms')}
                />
                {renderBuildingFilters}
                <MobileLandStatusSelectFilter
                    filter={filters.get(Filters.landStatus)}
                    onChange={updateFilter}
                />
                {filters.isRentFilterActive() && (
                    <MobileLivingFacilityFilterButtonView
                        filter={filters.get(Filters.livingFacility)}
                        handleChange={updateFilter}
                        classNameGroup={cn('grid-house-category')}
                    />
                )}
            </>)}
            <SupplyOptionsButtonFilterView
                supplyFilter={filters.get(Filters.supplyOptions)}
                heatingFilter={filters.isHouseFilterActive() ? filters.get(Filters.heating) : undefined}
                bathroomLocationFilter={filters.get(Filters.bathroomLocation)}
                handleChangeSupply={updateFewFilters}
                handleChange={updateFilter}
                classNameGroup={cn('grid-house-category')}
                isMobile
            />
        </>)}
        {filters.isFlatOrRoomFilterActive() && (<>
            {
                filters.isSellFlatFilterActive() && ! filters.isOnlySecond() &&
                <ClMobileFinishingTypeFilterView
                    handleChange={updateFilter}
                    filter={filters.get(Filters.finishingType)}
                    classNameGroup={cn('grid-house-category')}
                />
            }
            {
                ! filters.isOnlyNewBuildings() &&
                <MobileRenovationButtonFilterView
                    handleChange={updateFilter}
                    filter={filters.get(Filters.renovation)}
                    classNameGroup={cn('grid-house-category')}
                />
            }
            <MobileFloorFilterButtonView
                filter={filters.get(Filters.floor)}
                handleChange={updateFilter}
                classNameGroup={cn('grid-subgroup')}
            />
            {filters.isSellRoomFilterActive() || filters.isFlatFilterActive() ? (
                <div className={cn('filter-subsection-columns')}>
                    {filters.isFlatFilterActive() &&
                        <LivingAreaFromFilterView
                            isMobile
                            filter={filters.get(Filters.livingArea)}
                            handleChange={updateFilter}
                        />
                    }
                    {filters.isFlatFilterActive() || filters.isSellRoomFilterActive() ? (
                        <KitchenAreaFromFilterView
                            isMobile
                            filter={filters.get(Filters.kitchenArea)}
                            handleChange={updateFilter}
                        />
                    ) : null}
                </div>
            ) : null}
            {filters.isRentFilterActive() && (
                <MobileLivingFacilityFilterButtonView
                    filter={filters.get(Filters.livingFacility)}
                    handleChange={updateFilter}
                    classNameGroup={cn('grid-house-category')}
                />
            )}
            <MobileCeilHeightFilterButtonView
                filter={filters.get(Filters.cellHeight)}
                handleChange={updateFilter}
                classNameGroup={cn('grid-house-category')}
            />
            <MobileBathroomFilterButtonView
                filter={filters.get(Filters.bathroom)}
                handleChange={updateFilter}
                classNameGroup={cn('grid-house-category')}
            />
            {filters.isSellFilterActive() && (
                <MobileWindowDirectionFilterButtonView
                    filter={filters.get(Filters.windowsDirection)}
                    handleChange={updateFilter}
                    classNameGroup={cn('grid-house-category')}
                />
            )}
            {(filters.isRentFlatOrRoomFilterActive() ||
                filters.isSellFlatFilterActive() || filters.isHouseFilterActive()) && ! filters.isOnlyNewBuildings() && (
                <MobileFurnitureFilterButtonView
                    filter={filters.get(Filters.furniture)}
                    handleChange={updateFilter}
                    classNameGroup={cn('grid-house-category')}
                    // Для домов такая же логика как и для комнат
                    isRoom={filters.isRoomFilterActive() || filters.isHouseFilterActive()}
                />
            )}
            <MobileBalconyFilterButtonView
                filter={filters.get(Filters.balcony)}
                handleChange={updateFilter}
                classNameGroup={cn('grid-house-category')}
            />
        </>)}
    </>);

    const additionallyFilters = (<>
        <MobileAdditionallyOptionsFilterView
            photoFilter={filters.get(Filters.photoOptions)}
            onlineViewFilter={filters.get(Filters.onlineView)}
            layoutImageOptionFilter={filters.isFlatOrRoomFilterActive() ? filters.get(Filters.layoutImageOptions) : undefined}
            pitFilter={filters.isSellFlatFilterActive() ? filters.get(Filters.author) : undefined}
            handleChange={updateFilter}
            classNameGroup={cn('grid-house-category')}
            classNameSubGroup={cn('subgroup')}
            classNameSeparate={cn('separate')}
            isMap={! isMobile}
        />
        {filters.isSellFilterActive() && renderSellTypeFilter(updateFilter)}
    </>);

    const buildingInfoPart = (<>
        <MobileWallsFilterButtonsView
            filter={filters.get(Filters.walls)}
            handleChange={updateFilter}
            classNameGroup={cn('grid-house-category')}
        />
        {
            filters.isOnlyNewBuildings() ?
                <CommissioningDateFilter
                    filter={filters.get(Filters.commissioning)}
                    handleChange={updateFilter}
                    classNameGroup={cn('grid-house-category')}
                    isMobile
                /> :
                <YearBuildingFilterView
                    filter={filters.get(Filters.builtYear)}
                    handleChange={updateFilter}
                    // @ts-ignore
                    filter2={filters.get(Filters.buildEpoch)}
                    classNameGroup={cn('grid-house-category')}
                    isNewBuilding={filters.isOnlyNewBuildings()}
                    withoutEpochTitle
                    isMobile
                />
        }
        <FloorsTotalFilterView
            filter={filters.get(Filters.floorsTotal)}
            handleChange={updateFilter}
            isMobile
        />
        <MobileInfrastructureFilterButtonView
            filter={filters.get(Filters.infrastructure)}
            parkingFilter={filters.get(Filters.parkings)}
            handleChange={updateFilter}
            classNameGroup={cn('grid-house-category')}
        />
        {filters.isRenovationProgramFilterActive() && (
            <MobileRenovationProgramFilterButtonView
                filter={filters.get(Filters.renovationProgram)}
                handleChange={updateFilter}
            />
        )}
    </>);

    const rentPart = (<>
        <MobileSellerFilterButtonView
            filter={filters.get(Filters.author)}
            handleChange={updateFilter}
            classNameGroup={cn('grid-house-category')}
            isSecond
            isRentTitle
        />
        <MobileRentConditionsFilterButtonView
            handleChange={updateFilter}
            conditionFilter={filters.get(Filters.rentConditions)}
            tenantOptionFilter={filters.get(Filters.livingTenantOptions)}
            isHouse={filters.isHouseFilterActive()}
            classNameGroup={cn('grid-house-category')}
        />
        <MobilePrePaymentFilterButtonView
            filter={filters.get(Filters.rentPrepayment)}
            handleChange={updateFilter}
            classNameGroup={cn('grid-house-category')}
        />
        {filters.isFlatFilterActive() && (
            <MobileApartmentsButtonFilterView
                filter={filters.get(Filters.apartments)}
                handleChange={updateFilter}
                classNameGroup={cn('grid-subgroup')}
            />
        )}
    </>);

    const filterNodes = (<>
        <div className={cn('filter-section')}>
            {commonPart}
        </div>
        <div className={cn('filter-section')}>
            <Typography variant='h3'>
                Расположение
            </Typography>
            {locationPart}
        </div>
        {filters.isRentFilterActive() && (
            <div className={cn('filter-section')}>
                <Typography variant='h3'>
                    Объявление
                </Typography>
                {rentPart}
            </div>
        )}
        <div className={cn('filter-section')}>
            <Typography variant='h3'>
                {getFilterSectionTitleByCategory(filters.getCategoryTypeFilter().categoryType)}
            </Typography>
            {generalPart}
        </div>
        {filters.isFlatOrRoomFilterActive() && (<>
            <div className={cn('filter-section')}>
                <Typography variant='h3'>
                    Дом
                </Typography>
                {buildingInfoPart}
            </div>
            <div className={cn('filter-section')}>
                <Typography variant='h3'>
                    Район
                </Typography>
                <MobileDistrictFilterButtonView
                    filter={filters.get(Filters.nearbyOptions)}
                    handleChange={updateFilter}
                />
            </div>
        </>)}
        <div className={cn('filter-section')}>
            <Typography variant='h3'>
                Дополнительно
            </Typography>
            {additionallyFilters}
        </div>
    </>);

    return (
        <div className={cn(null, undefined, className)} ref={containerRef}>
            {prefixNodes}
            <div className={cn('filters')} onClick={handleInteractionOnFilter}>
                {filterNodes}
            </div>

            {renderDividerContent}
            {children}
        </div>
    );
});
